import { render, staticRenderFns } from "./Choro.vue?vue&type=template&id=5d49da76&scoped=true&lang=pug&"
import script from "./Choro.vue?vue&type=script&lang=js&"
export * from "./Choro.vue?vue&type=script&lang=js&"
import style0 from "./Choro.vue?vue&type=style&index=0&id=5d49da76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49da76",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
